import React from 'react';
import { Grid, Typography, Button } from '@material-ui/core';
import { Add as AddIcon } from '@material-ui/icons';
import { Link } from 'react-router-dom';

interface IProps {
    title: React.ReactNode | string
    subtitle?: React.ReactNode | string
    addNewUrl?: string
}

let PageHeader = ({ title, subtitle, addNewUrl }: IProps) => {
    return (
        <Grid container alignItems="center">
            <Grid item xs>
                {React.isValidElement(title) && title}
                {React.isValidElement(title) === false && <Typography variant="h3">{title}</Typography>}
                {subtitle &&
                    <>
                        {React.isValidElement(subtitle) && subtitle}
                        {React.isValidElement(subtitle) === false && <Typography variant="h5">{subtitle}</Typography>}
                    </>
                }
            </Grid>
            {addNewUrl &&
                <Grid item>
                    <Button
                        color="secondary"
                        variant="outlined"
                        component={Link}
                        to={addNewUrl}
                    >
                        <AddIcon />&nbsp;New
                    </Button>
                </Grid>
            }
        </Grid>
    );
}

export default PageHeader;